'use client'

import type { YMarketOrder } from '@/lib/types'
import type { MessageDispatch } from '@/lib/types'
import { messageStateFor } from '@/lib/message-state'
import { STATUS_COLORS, STATUS_LABELS, isDbsOrder } from '@/lib/order-helpers'
import { CheckIcon } from '@/components/icons'

interface Props {
  order: YMarketOrder
  messageStates: MessageDispatch[]
}

export function OrderDetailHeader({ order, messageStates }: Props) {
  const statusColor = STATUS_COLORS[order.status] || 'var(--color-ink-faint)'
  const statusLabel = STATUS_LABELS[order.status] || order.status
  const dbs = isDbsOrder(order)
  const first = messageStateFor({ messageStates }, 'firstMsg')
  const confirm = messageStateFor({ messageStates }, 'confirmMsg')

  return (
    <header className="mb-6">
      <div className="flex items-center gap-2.5 flex-wrap">
        <span className="text-[13px] text-ink-muted tab-nums font-medium">
          №{order.orderId}
        </span>

        <span className="text-ink-faint/40 text-[10px]">·</span>

        <span
          className="inline-flex items-center gap-1 px-2 h-[18px] rounded-full text-[10px] font-medium tracking-[0.03em]"
          style={{
            background: `color-mix(in srgb, ${statusColor} 12%, transparent)`,
            color: statusColor,
            border: `1px solid color-mix(in srgb, ${statusColor} 25%, transparent)`,
          }}
        >
          <span className="size-1 rounded-full shrink-0" style={{ background: statusColor }} />
          {statusLabel}
        </span>

        {!dbs && (
          <>
            <span className="text-ink-faint/40 text-[10px]">·</span>
            <span className="text-[10px] tracking-[0.08em] uppercase text-ink-faint font-medium">
              FBS
            </span>
          </>
        )}

        {(first || confirm) && (
          <>
            <span className="text-ink-faint/40 text-[10px]">·</span>
            {first && (
              <span className="inline-flex items-center gap-1 px-2 h-[18px] rounded-full text-[10px] font-medium bg-st-delivered/8 text-st-delivered border border-st-delivered/20 tracking-[0.02em]">
                <CheckIcon />
                Предув.
              </span>
            )}
            {confirm && (
              <span className="inline-flex items-center gap-1 px-2 h-[18px] rounded-full text-[10px] font-medium bg-st-delivered/8 text-st-delivered border border-st-delivered/20 tracking-[0.02em]">
                <CheckIcon />
                Подтв.
              </span>
            )}
          </>
        )}
      </div>
    </header>
  )
}
